<app-filter-results [filterBy]="filterBy" [isFilterInAvailable]="isFilterInVisible" [filterIn]="filterIn"
    [searchBy]="searchBy" [isSearchingAvailable]="true" (onApplyFilter)="applyFilter($event)"
    (resetFilters)="onResetFilters()" [filterOpen]="filterStatusParent" (closeNavEvent)="closeEvent($event)">
</app-filter-results>